import { constantRouterMap } from '@/config/router.config'
import { generatorDynamicRouter } from '@/utils/routerUtil'

const permission = {
    state: {
        routers: constantRouterMap,
        addRouters: [],
        hotKeys: ''
    },
    mutations: {
        SET_ROUTERS: (state, routers) => {
            state.addRouters = routers
            state.routers = constantRouterMap.concat(routers)
        },
        SET_HOTKEYS: (state, hotKeys) => {
            state.hotKeys = hotKeys
        }
    },
    actions: {
        /**
         * 构建获取和构建路由和菜单信息
         * @param commit
         * @param data
         * @returns {Promise<any>}
         * @constructor
         */
        GenerateRoutes({ commit }, data) {
            const routers = generatorDynamicRouter(data)
            commit('SET_ROUTERS', routers)
        },
        UpdateHotKeys({ commit }, hotkeys) {
            commit('SET_HOTKEYS', hotkeys)
        }
    }
}

export default permission
